import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {listOutline, listSharp} from "ionicons/icons"
import {useHistory} from "react-router";
import TimeLimit from "@customTypes/TimeLimit";

interface props {
    timeLimit: TimeLimit
}

const ListItemButtonData: React.FC<props> = ({ timeLimit }) => {

    const {t} = useTranslation()
        , history = useHistory()
        , [presentAlert] = useIonAlert()
        , dataCount: number = timeLimit.timeLimitData?.length || 0
        , translationKey: string = "time-limits.alerts." + (dataCount ? 'data' : 'no_data')

    const alertMessage = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        return presentAlert({
            header:  t(translationKey + '.header'),
            message: t(translationKey + '.message'),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel'
            }]
        })
    }

    const goToTimeLimitTimeLimitData = (ev: any) => {
        ev.preventDefault()
        ev.stopPropagation()

        if (dataCount) {
            return history.push('/time-limits/' + timeLimit.id + '/time-limit-data')
        }

        alertMessage(ev).then()
    }

    return (
        <IonButton color={dataCount > 1 ? "secondary" : (dataCount > 0 ? "medium" : "light")}
                   fill="clear"
                   shape="round"
                   onClick={ (ev) => goToTimeLimitTimeLimitData(ev) }
                   size="large"
                   style={{ 'fontSize': '1rem' }}
        >
            <IonIcon slot="start" ios={listOutline} md={listSharp} />
            {dataCount || '-'}
        </IonButton>
    )
}

export default ListItemButtonData